<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (inMenu) {
  <div mat-menu-item (click)='showLogout()'>
    @if (showIcon) {
      <mat-icon svgIcon="logout"></mat-icon>
    }
    <span>Sign out</span>
  </div>
} @else {
  @if (showIcon) {
    <button mat-icon-button
      (click)="showLogout()"
      matTooltip="Sign out">
      <mat-icon svgIcon="logout"></mat-icon>
    </button>
  } @else {
    <button mat-button (click)="showLogout()" matTooltip="Sign out">
      Sign Out
    </button>
  }
}




